import React from "react";

function ViewUnit({ data }) {
  return (
    <div>
      <h4>{data?.name}</h4>

      <p>{data?.description}</p>

      <h6>
        Status :{data?.status === 1 ? " Active" : " Inactive"}
      </h6>

    </div>
  );
}

export default ViewUnit;